export default "__VITE_ASSET__kAa16Ho1__"